import Axios from "axios";
var SourceCodeService = (function () {
    function SourceCodeService() {
    }
    SourceCodeService.prototype.getSourceCode = function (params) {
        return Axios.get("supplierclientapi/purchaseorder/print_code_detail", { params: params });
    };
    SourceCodeService.prototype.previewSourceCode = function (params) {
        return Axios.get("supplierclientapi/purchaseorder/print_code", { params: params });
    };
    SourceCodeService.prototype.getSourceCodeDelivery = function (params) {
        return Axios.get("supplierclientapi/deliveryorder/print_code_detail", { params: params });
    };
    SourceCodeService.prototype.previewSourceCodeDelivery = function (params) {
        return Axios.get("supplierclientapi/deliveryorder/print_code", { params: params });
    };
    SourceCodeService.prototype.getSourceCodeEntrustDelivery = function (params) {
        return Axios.get("supplierclientapi/entrust_delivery_order/print_code_detail", { params: params });
    };
    SourceCodeService.prototype.previewSourceCodeEntrustDelivery = function (params) {
        return Axios.get("supplierclientapi/entrust_delivery_order/print_code", { params: params });
    };
    SourceCodeService.createInstance = function () {
        SourceCodeService.getInstance();
    };
    SourceCodeService.getInstance = function () {
        return this._instance || (this._instance = new this());
    };
    return SourceCodeService;
}());
export default SourceCodeService;
